import { useEffect, useState } from 'react'
import {
  faSass,
  faCss3,
  faGitAlt,
  faHtml5,
  faJsSquare,
  faReact,
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            Full Stack Software Engineer with 4+ years of experience building
            scalable SaaS platforms, enterprise systems, AI-powered
            applications, and cross-platform mobile products.
          </p>
          <p align="LEFT">
            I own products end-to-end — from requirements analysis and system
            design through frontend, backend, cloud infrastructure, testing, and
            production deployment. My work spans React and Next.js frontends,
            Node.js / NestJS and Java / Spring Boot services, and Python /
            FastAPI microservices, with a focus on maintainable,
            high-performance systems that deliver real business impact.
          </p>
          <p>
            I design microservices, Backend-for-Frontend (BFF) architectures,
            event-driven systems with RabbitMQ and Kafka, multi-tenant
            platforms, and real-time applications built on WebSockets and
            Socket.IO — including SAML2 SSO, RBAC, and tenant-aware
            authorization across enterprise HR and SaaS products.
          </p>
          <p>
            I build production AI solutions using AWS Bedrock, Bedrock
            AgentCore, RAG, agentic tool calling, LLM streaming, Amazon
            Transcribe, Amazon Polly, and AWS S3, alongside native Android
            (Java) and iOS (Swift) applications featuring biometric
            authentication, push notifications, deep linking, and secure
            credential storage.
          </p>
          <p>
            Beyond development, I own production infrastructure and delivery —
            Docker, Nginx, CI/CD pipelines, database migrations, and
            observability — with a strong focus on system design, performance
            optimization, and automation.
          </p>
        </div>

        <div className="stage-cube-cont">
          <div id="stars"></div>
          <div id="stars2"></div>
          <div id="stars3"></div>

          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faSass} color="#c69" />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faHtml5} color="#F06529" />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
